// Offline/dev fallback for the map — used only when /api/photos?map=1 is
// unreachable (e.g. local dev without Vercel functions/env vars running).
// In production this is real photos with real { lat, lng } from EXIF GPS,
// served by api/photos.js. The city list below is illustrative only.

function thumb(src, size = 220) {
  if (!src) return '';
  if (src.includes('res.cloudinary.com')) {
    return src.replace('/upload/', `/upload/f_auto,q_auto,w_${size},h_${size},c_fill/`);
  }
  return src;
}
function full(src) {
  if (!src) return '';
  if (src.includes('res.cloudinary.com')) {
    return src.replace('/upload/', '/upload/f_auto,q_auto,w_1600/');
  }
  return src;
}
function pic(seed) { return `https://picsum.photos/seed/${seed}/600/600`; }

const REAL_LDN = [
  'https://res.cloudinary.com/dzwjxry2z/image/upload/v1775430481/20260405_173730_fvvnvk.jpg',
  'https://res.cloudinary.com/dzwjxry2z/image/upload/v1775430481/20260405_154152_xabfkz.jpg',
];

// city, country, lat, lng, photo count, month(YYYY-MM), seed
const CITIES = [
  ['London',      'United Kingdom', 51.5074,   -0.1278,  9,  '2026-04', 'ldn'],
  ['Tallinn',     'Estonia',        59.4370,   24.7536,  7,  '2026-02', 'tln'],
  ['Lisbon',      'Portugal',       38.7223,   -9.1393,  6,  '2025-09', 'lis'],
  ['Berlin',      'Germany',        52.5200,   13.4050,  6,  '2025-06', 'bln'],
  ['Paris',       'France',         48.8566,    2.3522,  5,  '2025-05', 'par'],
  ['Amsterdam',   'Netherlands',    52.3676,    4.9041,  4,  '2025-04', 'ams'],
  ['Barcelona',   'Spain',          41.3874,    2.1686,  5,  '2024-10', 'bcn'],
  ['Rome',        'Italy',          41.9028,   12.4964,  5,  '2024-09', 'rom'],
  ['Prague',      'Czechia',        50.0755,   14.4378,  4,  '2024-06', 'prg'],
  ['Reykjavik',   'Iceland',        64.1466,  -21.9426,  4,  '2024-03', 'rey'],
  ['Istanbul',    'Türkiye',        41.0082,   28.9784,  5,  '2023-11', 'ist'],
  ['Marrakech',   'Morocco',        31.6295,   -7.9811,  4,  '2023-10', 'mar'],
  ['Dubai',       'UAE',            25.2048,   55.2708,  3,  '2023-05', 'dxb'],
  ['Delhi',       'India',          28.6139,   77.2090,  7,  '2023-01', 'del'],
  ['Bangkok',     'Thailand',       13.7563,  100.5018,  5,  '2022-12', 'bkk'],
  ['Tokyo',       'Japan',          35.6762,  139.6503,  8,  '2022-10', 'tyo'],
  ['Singapore',   'Singapore',       1.3521,  103.8198,  4,  '2022-09', 'sin'],
  ['New York',    'United States',  40.7128,  -74.0060,  6,  '2022-05', 'nyc'],
  ['Mexico City', 'Mexico',         19.4326,  -99.1332,  4,  '2021-11', 'mex'],
  ['Cape Town',   'South Africa',  -33.9249,   18.4241,  5,  '2021-08', 'cpt'],
];

function jitter(seed, i, axis) {
  const x = Math.sin((seed.charCodeAt(0) + seed.charCodeAt(seed.length - 1)) * (i + 1) * (axis === 'lat' ? 12.9898 : 78.233)) * 43758.5453;
  return ((x - Math.floor(x)) - 0.5) * 0.06;
}

export function buildMockPhotos() {
  const photos = [];
  let id = 0;
  CITIES.forEach(([city, country, lat, lng, n, ym, seed]) => {
    for (let i = 0; i < n; i++) {
      const day = String(3 + ((i * 4) % 25)).padStart(2, '0');
      const date = `${ym}-${day}`;
      const src = (seed === 'ldn' && i < REAL_LDN.length) ? REAL_LDN[i] : pic(`${seed}${i + 1}`);
      photos.push({
        id: id++,
        src,
        thumb: thumb(src, 220),
        full: full(src),
        date,
        city,
        country,
        location: `${city}, ${country}`,
        lat: lat + jitter(seed, i, 'lat'),
        lng: lng + jitter(seed, i, 'lng'),
      });
    }
  });
  return photos;
}
